import * as z from "zod";
import { OC } from "../../utils";
import { AdminEmployee } from "./schema";

export const employeeContract = OC.router({
  get: OC.meta({ permissions: ["employee:get"] })
    .input(AdminEmployee.Get)
    .output(AdminEmployee.Employee),
  getAll: OC.meta({ permissions: ["employee:get"] })
    .input(AdminEmployee.GetAll)
    .output(
      z.array(
        AdminEmployee.Employee.extend({
          number: z.number(),
        }),
      ),
    ),
  count: OC.meta({ permissions: ["employee:get"] })
    .input(
      AdminEmployee.GetAll.omit({
        page: true,
        limit: true,
        sortBy: true,
        sortOrder: true,
      }),
    )
    .output(z.number()),
  create: OC.meta({
    alters: true,
    permissions: true,
    auditLog: { modelName: "EMPLOYEE", action: "CREATE" },
    aragon: "employee_created",
  })
    .input(AdminEmployee.Create)
    .output(AdminEmployee.Employee),
  update: OC.meta({
    alters: true,
    permissions: true,
    auditLog: { modelName: "EMPLOYEE", action: "UPDATE" },
    aragon: "employee_updated",
  })
    .input(AdminEmployee.Update)
    .output(AdminEmployee.Employee),
  delete: OC.meta({
    alters: true,
    permissions: true,
    auditLog: { modelName: "EMPLOYEE", action: "DELETE" },
    aragon: "employee_deleted",
  })
    .input(AdminEmployee.Delete)
    .output(AdminEmployee.Employee.omit({ role: true })),
  checkUsernameAvailable: OC.input(
    z.object({ username: z.string().toLowerCase() }),
  ).output(z.object({ id: z.string().nullable() })),
  updatePassword: OC.meta({
    alters: true,
    permissions: true,
    auditLog: { modelName: "EMPLOYEE", action: "UPDATE" },
    aragon: "employee_password_updated",
  })
    .input(AdminEmployee.UpdatePassword)
    .output(AdminEmployee.Employee.omit({ role: true })),
});
